export const register = {
  "titleInvite": "Accept Invitation",
  "subtitleInvite": "Create your account to join the team.",
  "titlePublic": "Create Your Store Account",
  "subtitlePublic": "Sign up to get started with GreenLeaf POS.",
  "validating": "Verifying invitation...",
  "invalidTitle": "Invitation Invalid",
  "nameLabel": "Full Name",
  "emailLabel": "Email",
  "emailHint": "This email is tied to your invitation.",
  "passwordLabel": "Password (min. 6 characters)",
  "confirmPasswordLabel": "Confirm Password",
  "passwordMismatch": "Passwords do not match.",
  "creatingButton": "Creating Account...",
  "completeButton": "Complete Registration",
  "createButton": "Create Account",
  "loginLink": "Already have an account? Sign In"
};
